export const getJSState = token => {
  if (!token) return;
  let s = token.state;
  while (s && s.inner) s = s.inner;
  if (s && 'localVars' in s) return s;
};
export const isVariableToken = token => /\bvariable\b/.test(token.type);
export const validVarNameRe = /^[\w$\u4e00-\u9fa5]+$/; // 中文字符、\w 和美元符
/**
 * 找到补全的范围，比如现在光标位置是在 `foo.bar.ba|z` 那么就提取出 "foo.bar" 以及 "ba"
 *
 * 如果提取失败会返回 undefined
 *
 * @param editor
 * @param cur
 */
export function getUnfinishedDataPathAt(editor, cur = editor.getCursor()) {
  let prevPath = '';
  let blurryPart = '';
  const lineTokens = editor.getLineTokens(cur.line);
  if (!lineTokens.length) return {
    prevPath,
    blurryPart
  }; // 空行
  // 先找到当前所在的token
  let idx = 0;
  while (idx < lineTokens.length && lineTokens[idx].end < cur.ch) idx += 1;
  const lastToken = lineTokens[idx];
  if (!lastToken || !getJSState(lastToken)) return; // nothing
  if (/\b(?:string|comment)\b/.test(lastToken.type)) return;
  blurryPart = lastToken.string.substr(0, cur.ch - lastToken.start);
  let blurryPartIsProperty = !isVariableToken(lastToken);
  if (blurryPart === '.' || blurryPart === '?.') {
    blurryPart = '';
  } else if (!validVarNameRe.test(blurryPart)) {
    blurryPart = '';
    blurryPartIsProperty = false;
  }
  // 如果当前是 var| 这种 就直接结束
  // 否则要收集 foo.bar.ba| 前面的 foo.bar.
  if (blurryPartIsProperty) {
    // 具体的，是向前搜索，找到第一个 type 是 variable 的，他就是变量的开始
    idx -= 1;
    while (idx >= 0) {
      const token = lineTokens[idx];
      let key = token.string;
      if (key === '?.') key = '.';
      prevPath = key + prevPath;
      if (isVariableToken(token)) break;
      idx -= 1;
    }
  }
  return {
    prevPath,
    blurryPart
  };
}
//# sourceMappingURL=js-token.js.map
